/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListResourcesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListResourcesRequest = {
  /**
   * The cursor to fetch results from
   */
  cursor?: string | undefined;
  /**
   * The number of resources to return per page
   */
  limit?: number | undefined;
  /**
   * The deployment ID. If unset, latest deployment will be used.
   */
  deploymentId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListResourcesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListResourcesSecurity$outboundSchema: z.ZodMiniType<
  ListResourcesSecurity$Outbound,
  ListResourcesSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listResourcesSecurityToJSON(
  listResourcesSecurity: ListResourcesSecurity,
): string {
  return JSON.stringify(
    ListResourcesSecurity$outboundSchema.parse(listResourcesSecurity),
  );
}

/** @internal */
export type ListResourcesRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  deployment_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListResourcesRequest$outboundSchema: z.ZodMiniType<
  ListResourcesRequest$Outbound,
  ListResourcesRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    deploymentId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listResourcesRequestToJSON(
  listResourcesRequest: ListResourcesRequest,
): string {
  return JSON.stringify(
    ListResourcesRequest$outboundSchema.parse(listResourcesRequest),
  );
}
